export const Constant = {
  DEFAULT_DURATION_IN_MS: 500,
  DEFAULT_DELAY_IN_MS: 0,

  DAMPING: 2,
  REST_SPEED_THRESHOLD: 0.1,

  // វាដូចជារូស័រ បើសិន stiffness ច្រើនរូស័រមិនអាចទាញបានឆ្ងាយទេ
  STIFFNESS: 1000,
  VELOCITY: 3,
};
